export default __webpack_public_path__ + "static/media/Prior-Intimation-of-Board-Meeting-1.05327de3.pdf";